// extracted by mini-css-extract-plugin
export default {"root":"NotFoundIntro_root__1EwyI","content":"NotFoundIntro_content__SWdJs","text":"NotFoundIntro_text__XC5mo"};